import { PlotData } from 'plotly.js'

/**
 * Export Plotly chart data to CSV format
 */
export const exportChartDataToCSV = (plotlyData: Partial<PlotData>[]): void => {
  const xAxisDict: Record<string, Record<string, number>> = {}

  plotlyData.forEach((trace) => {
    if (trace.x && trace.y) {
      trace.x.forEach((xVal, i) => {
        if (!(typeof xVal === 'number')) return
        const yVal = trace.y?.[i]
        if (yVal !== null) {
          if (!xAxisDict[xVal]) {
            xAxisDict[xVal] = {}
          }
          if (typeof yVal === 'number') {
            xAxisDict[xVal][trace.name as string] = yVal
          }
        }
      })
    }
  })

  const rows: string[] = []
  const header = ['X Value'].concat(
    plotlyData.map((trace) => trace.name as string)
  )
  rows.push(header.join(','))

  Object.entries(xAxisDict).forEach(([xVal, yVals]) => {
    const row = [xVal]
    plotlyData.forEach((trace) => {
      row.push(yVals[trace.name ?? ''].toString() ?? '')
    })
    rows.push(row.join(','))
  })

  const csv = rows.join('\n')
  downloadCSV(csv, 'time-series-data.csv')
}

/**
 * Download CSV file
 */
export const downloadCSV = (csv: string, filename: string): void => {
  const blob = new Blob([csv], {
    type: 'text/csv;charset=utf-8;',
  })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

/**
 * Export chart as image
 */
export const getChartImageOptions = () => ({
  format: 'png' as const,
  filename: 'time-series-chart',
  height: 600,
  width: 1200,
  scale: 1,
})
